module.exports = __webpack_public_path__ + "img/7.7347a44e.png";